import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/video-chatbot/PageContent.tsx");
